export enum UserOrganizationRole
{
    User = 1,
    Administrator = 2
}